/**
* 模版
**/ 

<template>
  <div style="width: 1200px; margin: auto">
    <div class="container join_in_top">
      <div class="title">选择入驻商家类型</div>
      <div
        class="rowBox"
        style="
          width: 70%;
          margin: auto;
          display: flex;
          justify-content: space-around;
        "
      >
        <div class="column col-xs-12 col-sm-6">
          <div
            class="select-row"
            @mouseenter="mouseOverNormal()"
            @mouseleave="mouseOverNormal()"
          >
            <div class="select-row-detail" v-show="normalShow">
              <el-image class="supplier_img" :src="require('@/assets/img/shop.png')"></el-image>
              <p class="typeName">普通商家</p>
              <p class="typeintroduce">
                精选好货,服务保证,提供正品低价的购物选择,满足各种购物需求。
              </p>
            </div>
            <div class="select-row-option" v-show="!normalShow">
              <el-button
                size="small"
                @click="goToSettleInStep(2)"
                >我要入驻</el-button
              >
            </div>
          </div>
        </div>

        <div class="column col-xs-12 col-sm-6">
          <div
            class="select-row"
            @mouseenter="mouseOverProduct()"
            @mouseleave="mouseOverProduct()"
          >
            <div class="select-row-detail" v-show="productShow">
              <el-image class="supplier_img" :src="require('@/assets/img/supplier.png')"></el-image>
              <p class="typeName">供应商</p>
              <p class="typeintroduce">
                提供各种商品的优质低价货源,上万件优质产品,同步更新,超低折扣供货,一件代发。
              </p>
            </div>
            <div class="select-row-option" v-show="!productShow">
              <el-button
                size="small"
                @click="goToSettleInStep(1)"
                >我要入驻</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="welcomeTabs">
       <el-tabs type="border-card">
              <el-tab-pane :label="item.head" v-for="(item,index) in rulelists" :key="index">
                  <p v-html="item.work"></p>
              </el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>

<script>
// // 导入组件
// import headerComponent from "./head.vue";
import {redEnvelope,getMercharntStep,shopPass} from '@/api/xunyou'
// 导出模块
export default {
  // 模块名字
  name: "",
  // 模块数据
  data() {
    //数据
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      normalShow: true,
      productShow: true,
      rulelists:[]
    };
  },
  // 注册组件
  components: {},
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  // 创建前状态(里面是操作)
  beforeCreate() {},
  // 创建完毕状态(里面是操作)
  created() {},
  // 挂载前状态(里面是操作)
  beforeMount() {},
  // 挂载结束状态(里面是操作)
  mounted() {
    this.shopRules()
  },
  // 更新前状态(里面是操作)
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    shopRules(){
      shopPass().then(res=>{
        if(res.code==0){
          this.rulelists = res.rows
        }
      })
    },
    //   鼠标移入移出
    mouseOverNormal() {
      this.normalShow = !this.normalShow;
    },
    mouseOverProduct() {
      this.productShow = !this.productShow;
    },

    // 状态判断，不同的状态跳到相应的页面
    statusType(status,type){
       switch(status) {
            case 1: //第一步，填资料 默认的
                return  this.$router.push(`/merchantApply?type=${type}`)
                break;
            case 2: // 审核中
                 return this.$router.push('/merchantStatus')
                break;
            case 3: // 资料审核通过，待付款
                 return this.$router.push('/merchantpayFor')
                break;
            case 4: // 审核通过
                 return this.$router.push('/storeOpen')
            default:                
                return '--'
        } 
    },
    // 我要入驻
    goToSettleInStep(type){
      getMercharntStep({username:this.userInfo.loginName}) // username为账户名,后期需要改
            .then(res => {
              if (res.code == 0) {
                console.log(res.data,type,'dianpu1')
                this.statusType(res.data,type)
              } else {
                this.$message({
                  type: 'info',
                  message: '查询失败，请稍后再试！'
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('查询失败，请稍后再试！')
            })
     
    }
  },
};
</script>
<style scoped lang='less'>
.join_in_top {
  min-height: 350px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 20px;
  .title {
    font-size: 20px;
    text-align: center;
    padding: 20px 0 0;
  }
  .select-row {
    width: 280px;
    height: 280px;
    margin-right: 10px;
    overflow: hidden;
    border: 1px solid #e7e7eb;
    font-size: 14px;
    margin: 35px auto;
    .select-row-detail {
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .supplier_img{
          width: 30%;
          left: 50%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -20%);
      }
      p.typeName {
        text-align: center;
        font-size: 16px;
      }
      p.typeintroduce {
        padding: 5px 38px;
        box-sizing: border-box;
      }
      // .select-row-detail dl .name {
      //     color: #222;
      //     font-size: 16px;
      //     text-align: center;
      // }
    }
    .select-row-option {
      width: 100%;
      height: 100%;
      position: relative;
      // display: none;
      .el-button {
        background: #78b942;
        border: 1px solid #78b942;
        color: #ffffff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
.welcomeTabs {
  /deep/.el-tabs--border-card {
    border: none !important;
    box-shadow: none !important;
  }
  /deep/.el-tabs--border-card > .el-tabs__header {
    background-color: #f7f8f8 !important;
    border-bottom: none !important;
  }
  strong.title,.typeintroduce {
    font-size: 14px;
  }
  strong.smallTtile {
    font-size: 20px;
    display: block;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/merchantSettled/merchantTypeSelect.vue